/**
 * Карта маршрутов (§3). Сайдбара нет, вся навигация — в шапке.
 *
 * Два решения по структуре:
 *  · карточка бренда — вложенный маршрут внутри `/brands`, потому что по §7
 *    она панель поверх таблицы: таблица остаётся живой и сжимается;
 *  · `/changes/:id` — deep-link из Telegram, по §3 ведёт на `/history/:id`.
 *
 * Неизвестный путь уводит на главную.
 */
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { ComponentsPreview } from '../dev/ComponentsPreview.js'
import { BrandCardScreen } from '../features/brands/BrandCardScreen.js'
import { BrandsScreen } from '../features/brands/BrandsScreen.js'
import { CategoriesScreen } from '../features/catalog/CategoriesScreen.js'
import { EnumsScreen } from '../features/catalog/EnumsScreen.js'
import { DigestScreen } from '../features/digest/DigestScreen.js'
import { DraftReviewScreen } from '../features/draft/DraftReviewScreen.js'
import { FieldsScreen } from '../features/fields/FieldsScreen.js'
import { ChangeSetScreen } from '../features/history/ChangeSetScreen.js'
import { HistoryScreen } from '../features/history/HistoryScreen.js'
import { SettingsScreen } from '../features/settings/SettingsScreen.js'
import { UsersScreen } from '../features/users/UsersScreen.js'
import { texts } from '../texts.js'
import { RequirePermission } from './RequirePermission.js'

/** `/changes/:id` → `/history/:id` (§3: deep-link из Telegram). */
function ChangeSetDeepLink() {
  const { id = '' } = useParams()
  return <Navigate to={`/history/${id}`} replace />
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/brands" element={<BrandsScreen />}>
        <Route path=":slug" element={<BrandCardScreen />} />
      </Route>

      <Route path="/draft" element={<DraftReviewScreen />} />
      <Route path="/digest" element={<DigestScreen />} />

      <Route
        path="/history"
        element={
          <RequirePermission need="history.view" reason={texts.denied.history}>
            <HistoryScreen />
          </RequirePermission>
        }
      />
      <Route
        path="/history/:id"
        element={
          <RequirePermission need="history.view" reason={texts.denied.history}>
            <ChangeSetScreen />
          </RequirePermission>
        }
      />
      <Route path="/changes/:id" element={<ChangeSetDeepLink />} />

      <Route
        path="/catalog/categories"
        element={
          <RequirePermission need="catalog.categories.manage" reason={texts.denied.catalog}>
            <CategoriesScreen />
          </RequirePermission>
        }
      />
      <Route
        path="/catalog/enums"
        element={
          <RequirePermission need="catalog.enums.manage" reason={texts.denied.catalog}>
            <EnumsScreen />
          </RequirePermission>
        }
      />
      {/* §9.3: на этапе 1 список полей открыт на просмотр всем, поэтому без ограждения. */}
      <Route path="/fields" element={<FieldsScreen />} />
      <Route
        path="/users"
        element={
          <RequirePermission need="users.manage" reason={texts.denied.users}>
            <UsersScreen />
          </RequirePermission>
        }
      />
      <Route
        path="/settings"
        element={
          <RequirePermission need="settings.manage" reason={texts.denied.settings}>
            <SettingsScreen />
          </RequirePermission>
        }
      />

      <Route path="/" element={<Navigate to="/brands" replace />} />
      {/* Служебная витрина дизайн-системы: смотрим компоненты глазами. */}
      <Route path="/dev/components" element={<ComponentsPreview />} />
      <Route path="*" element={<Navigate to="/brands" replace />} />
    </Routes>
  )
}
